<template>
  <div class="crawler-box-panel">
    <el-card class="workspace-card crawler-toolbar-card" shadow="hover">
      <template #header>
        <div class="card-header">
          <span>马自达测试接头处理</span>
          <el-button :loading="crawlerBoxLoading" @click="loadCrawlerBoxes">刷新</el-button>
        </div>
      </template>

      <div class="crawler-summary-strip">
        <div class="crawler-summary-item">
          <span>Redis Hash</span>
          <strong>CrawlerBox</strong>
        </div>
        <div class="crawler-summary-item">
          <span>已打开</span>
          <strong>{{ crawlerBoxEnabledCount }}</strong>
        </div>
        <div class="crawler-summary-item">
          <span>已关闭</span>
          <strong>{{ crawlerBoxDisabledCount }}</strong>
        </div>
      </div>

      <div class="crawler-toolbar">
        <el-input
          v-model="newCrawlerBox"
          class="crawler-new-input"
          clearable
          maxlength="12"
          show-word-limit
          placeholder="输入 12 位接头"
          @keyup.enter="submitAddCrawlerBox"
        />
        <el-button type="primary" :loading="crawlerBoxSaving" @click="submitAddCrawlerBox">添加接头</el-button>
        <el-input
          v-model="crawlerBoxKeyword"
          class="crawler-search-input"
          clearable
          placeholder="搜索接头 / 状态"
        />
      </div>
    </el-card>

    <el-card class="workspace-card crawler-list-card" shadow="hover">
      <template #header>
        <div class="card-header">
          <span>接头列表</span>
          <div class="crawler-total-text">筛选后 {{ crawlerBoxFilteredItems.length }} 条 / 共 {{ crawlerBoxTotal }} 条</div>
        </div>
      </template>

      <el-table
        :data="crawlerBoxFilteredItems"
        stripe
        border
        class="crawler-table"
        v-loading="crawlerBoxLoading"
        empty-text="暂无测试接头"
        row-key="ucbox"
      >
        <el-table-column prop="ucbox" label="接头" min-width="180" />
        <el-table-column label="状态" min-width="220">
          <template #default="scope">
            <div class="crawler-status-editor">
              <el-switch
                v-model="scope.row.status"
                :loading="crawlerBoxSaving"
                active-value="TRUE"
                inactive-value="FALSE"
                active-text="打开"
                inactive-text="关闭"
                @change="(value) => updateCrawlerBoxStatus(scope.row, value)"
              />
              <el-tag :type="scope.row.status === 'TRUE' ? 'success' : 'info'" effect="light">
                {{ scope.row.status }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="redisKey" label="Key" min-width="160" />
        <el-table-column label="操作" width="120" align="center" class-name="action-column">
          <template #default="scope">
            <el-button size="small" type="danger" plain :loading="crawlerBoxSaving" @click="deleteCrawlerBox(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script setup>
import { toRef } from 'vue';
import { useMazdaCrawlerBox } from '@/composables/mazda/useMazdaCrawlerBox';

const props = defineProps({
  serverName: { type: String, required: true },
  mazdaPost: { type: Function, required: true },
});

const {
  crawlerBoxTotal,
  crawlerBoxEnabledCount,
  crawlerBoxDisabledCount,
  crawlerBoxKeyword,
  newCrawlerBox,
  crawlerBoxLoading,
  crawlerBoxSaving,
  crawlerBoxFilteredItems,
  loadCrawlerBoxes,
  submitAddCrawlerBox,
  updateCrawlerBoxStatus,
  deleteCrawlerBox,
} = useMazdaCrawlerBox(props.mazdaPost, toRef(props, 'serverName'));
</script>

<style scoped>
.crawler-box-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.workspace-card {
  border-radius: 18px;
  border: 1px solid rgba(225, 232, 242, 0.95);
  box-shadow: 0 10px 24px rgba(29, 46, 76, 0.06);
}

.workspace-card :deep(.el-card__body) {
  padding-top: 14px;
  padding-bottom: 14px;
}

.card-header,
.crawler-toolbar,
.crawler-status-editor {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-header {
  justify-content: space-between;
  font-weight: 800;
  color: #1f2d3d;
}

.crawler-summary-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(140px, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.crawler-summary-item {
  padding: 12px 14px;
  border-radius: 14px;
  background: linear-gradient(180deg, #fbfcff, #f6f9ff);
  border: 1px solid #e8eef8;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.crawler-summary-item span,
.crawler-total-text {
  color: #8a94a6;
  font-size: 12px;
}

.crawler-summary-item strong {
  color: #252f3f;
  word-break: break-all;
}

.crawler-toolbar {
  flex-wrap: wrap;
  padding: 12px;
  border: 1px solid #edf2fb;
  border-radius: 16px;
  background: #fbfcff;
}

.crawler-new-input {
  width: 240px;
}

.crawler-search-input {
  width: 280px;
  margin-left: auto;
}

.crawler-table {
  width: 100%;
}

.crawler-status-editor {
  flex-wrap: wrap;
}

:deep(.action-column .cell) {
  overflow: visible;
  text-overflow: clip;
  white-space: nowrap;
  padding-left: 8px;
  padding-right: 8px;
}

@media (max-width: 900px) {
  .crawler-summary-strip {
    grid-template-columns: 1fr;
  }

  .crawler-new-input,
  .crawler-search-input {
    width: 100%;
    margin-left: 0;
  }

  .crawler-toolbar {
    align-items: stretch;
  }
}
</style>
